import styled, { css } from 'styled-components';

export const RootStyled = styled.fieldset`
  padding: 0;
  margin: 0;
  border: none;
  display: inline-flex;
`;

export const OptionsStyled = styled.div<{ $orientation: 'vertical' | 'horizontal' }>`
  display: inline-flex;
  gap: 16px;

  ${({ $orientation }) =>
    $orientation === 'horizontal'
      ? css`
          flex-direction: row;
        `
      : css`
          flex-direction: column;
        `}
`;

export const LegendStyled = styled.legend`
  ${({ theme }) => theme.typography.body2};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
  padding: 0;
  margin-bottom: 8px;
`;
